










































import Vue from "vue";

import { mapActions, mapState } from "vuex";
import * as act from "@/store/modules/DashboardModule/actions";
import { Dashboard } from "@/model/data/dashboard/Dashboard";

import EditDashboardCard from "./EditDashboardCard.vue";
import SingleDashboardEntry from "./SingleDashboardEntry.vue";
import { RootState } from "@/store";
import { ClientUser } from "@/model/data/authentication/ClientUser";
import { UpdateCurrentUserCommand } from "@/model/communication/auth/UpdateCurrentUserCommand";
import { GET_CURRENT_USER } from "@/store/modules/AuthenticationModule/actions";

export default Vue.extend({
    components: { EditDashboardCard, SingleDashboardEntry },
    data() {
        return {
            dashboard: new Dashboard(),
            newDashboardDialog: false,
            addDefautlDashboardLoading: false,
            loadingDashboardList: false,
        };
    },
    computed: {
        ...mapState({
            dashboards: (state: RootState) => state.dashboard.dashboards,
            currentUser: (state: RootState) => state.authMod.currentUser,
        }),
        userConfig() {
            return this.currentUser.userConfig;
        },
    },
    methods: {
        ...mapActions([act.FETCH_DASHBOARD_LIST, GET_CURRENT_USER]),
        async onFetchDashboards() {
            this.loadingDashboardList = true;
            await this[act.FETCH_DASHBOARD_LIST]();
            this.loadingDashboardList = false;
        },
        onAddNewDashboardClick() {
            this.dashboard = new Dashboard();
            this.newDashboardDialog = true;
        },
        async moveDashboard(isDown: boolean, dashboardId: number) {
            this.loadingDashboardList = true;

            let newDashboardIdOrder: number[] = this.dashboards.map((d) => d.id);

            let fromIndex = newDashboardIdOrder.indexOf(dashboardId);
            let toIndex = newDashboardIdOrder.indexOf(dashboardId) + (isDown ? +1 : -1);

            let temp = newDashboardIdOrder[toIndex];
            newDashboardIdOrder[toIndex] = newDashboardIdOrder[fromIndex];
            newDashboardIdOrder[fromIndex] = temp;

            let reqData = (this.currentUser as ClientUser).createUpdateCurrentUserReqData();
            reqData.userConfig.dashboardList = newDashboardIdOrder;
            await new UpdateCurrentUserCommand(reqData).execute();
            await this[GET_CURRENT_USER]();

            this.loadingDashboardList = false;

            this.onFetchDashboards();
        },
        canMoveDashboard(isDown: boolean, dashboardId: number): boolean {
            if (isDown) {
                // non deve essere l'ultima
                let lastDashboarId = this.dashboards[this.dashboards.length - 1].id;
                return dashboardId != lastDashboarId;
            } else {
                let firstDashboarId = this.dashboards[0].id;
                return dashboardId != firstDashboarId;
            }
        },
    },
    created() {
        this.onFetchDashboards();
    },
});
